<template>
  <div>
    <div
      v-if="error == 'backError'"
      class="container-fluid"
    >
      <div class="row">
        <b-card
          title="Oh no!"
          tag="article"
          style="max-width: 20rem; margin: auto;"
          class="mb-2"
        >
          <b-card-text>
            Could not load the requested content. <br>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Errors',
  props: {
    error: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="css" scoped>
</style>
